import type { FaireProductEntity } from "../../entity_types/product";

export const p_j8agz743k5: FaireProductEntity = {
  token: "p_j8agz743k5",
  type: "product",
  name: "Ollokit First Aid - 5 Homeopathic Remedies",
  brandToken: "b_9jm6t3tbjk",
  brandName: "Ollois",
  imageUrl:
    "https://cdn.faire.com/fastly/77694b228f7651a463b5bcee21de86fdf8599fcc4314b30073e1064c30eb5496.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d3475bcf3f3f3b61b8a0f7911a6d0ecef1cee04295ff58becb93d27b631abbc0.webp",
    "https://cdn.faire.com/fastly/7fa53fda3f868377cb5776218dd416c393075937c9a725238cfe9ae4c41f9893.png",
    "https://cdn.faire.com/fastly/8ff5703f2191b25eb679508148db05270525ce8bb687012e2b4183fd3524c94c.png",
    "https://cdn.faire.com/fastly/bc0399b2f0088b7c47b44ebb8592c6170b86a1492b26ccec3d5efbdc29c0295a.jpeg",
    "https://cdn.faire.com/fastly/2e41c3540ace07cc24d1bf81787125a1474814db293abbe5118074bf639c6248.png",
    "https://cdn.faire.com/fastly/f1ead6517d993628bbc12579b4e65b53d784cc599883c4eb54b3a27a5b2ca1de.png",
    "https://cdn.faire.com/fastly/af0cc08df8daefc7fd85d86c75cce1006c5df4845171021b0aac47f54129c657.jpeg",
    "https://cdn.faire.com/fastly/01eec48c3ab1a552dd053d424c9959c64b80426d81a966a74d1b3bbdb1d60a6e.png",
    "https://cdn.faire.com/fastly/0c280911aeaad31297f62bafc3b80378a145603e17e76b3ed5f63b87d3e17b68.jpeg",
  ],
  priceDollars: 24.34,
  description:
    "Save with Olloïs Kits! Convenient carriers for your organic, lactose free, vegan and Kosher homeopathic needs!\n\nOlloïs First Aid Kit contains:\n\n * 1 tube of Arnica Montana 12C: traditionally used for pain from muscle soreness, stiffness, swelling - bruises.* \n * 1 tube of Hypericum Perforatum 30C: traditionally used for nerve pain after surgery or injury.* \n * 1 tube of Ruta Graveolens 30C: traditionally used for sprains & tendonitis - strains.* \n * 1 tube of Staphysagria 30C: traditionally used for cuts & surgical wounds.* \n * 1 tube of Symphytum Officinale 30C: bone trauma.*\n * 1 Free Portable Case ($14.99 value)\n\nApprox. 80 pellets per tube.\nOrganic verified by Alpes Contrôle 2021/A03M216K/1\nDosage: Dissolve 5 pellets under the tongue, 3 times a day\n\n*Disclaimer:\nClaims based on traditional homeopathic practice, not accepted medical evidence. Not FDA evaluated. Not guaranteed to be effective. A homeopathic dilution may not be susceptible to scientific measurement.\n",
  tags: [],
  msrpDollars: 48.68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:53.021Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
